(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dm-compare"]) return;
  try {
    
(() => {
  const updatePrices = () => {
    document.querySelectorAll('[data-compare-prices]').forEach(section => {
      const currency = section.dataset.currency;
      const locale = section.dataset.locale || 'en';
      const shopCurrency = window.Shopify && window.Shopify.currency;
      const canConvert = section.dataset.baseCurrency === 'USD' && shopCurrency && shopCurrency.active === currency && Number.isFinite(Number(shopCurrency.rate)) && Number(shopCurrency.rate) > 0;
      section.querySelectorAll('[data-variant-id][data-price]').forEach(element => {
        const price = Number(element.dataset.price);
        if (!Number.isFinite(price)) return;
        try { element.textContent = new Intl.NumberFormat(locale, {style:'currency',currency,currencyDisplay:'code'}).format(price / 100); } catch (_) {}
      });
      section.querySelectorAll('[data-usd]').forEach(element => {
        const usd = Number(element.dataset.usd);
        const converted = canConvert && currency !== 'USD';
        const displayCurrency = converted ? currency : 'USD';
        const amount = converted ? usd * Number(shopCurrency.rate) : usd;
        try {
          element.querySelector('[data-converted-value]').textContent = (converted ? '≈ ' : '') + new Intl.NumberFormat(locale, {style:'currency',currency:displayCurrency,currencyDisplay:'code'}).format(amount);
          element.querySelector('[data-usd-original]').hidden = !converted;
        } catch (_) {}
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updatePrices, {once:true}); else updatePrices();
  document.addEventListener('shopify:section:load', updatePrices);
  window.addEventListener('pageshow', updatePrices);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dragonmoss-ready-made-landing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dm-ready-made-catalog')) {
    customElements.define(
      'dm-ready-made-catalog',
      class extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

          this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => this.selectTab(tab));
            tab.addEventListener('keydown', (event) => this.handleKeydown(event, tab));
          });

          this.addEventListener('click', (event) => {
            const button = event.target.closest('[data-companion-quick-add]');
            if (button) this.addCompanionToCart(button);
          });
        }

        async addCompanionToCart(button) {
          if (button.disabled) return;

          const originalLabel = button.textContent;
          button.disabled = true;
          button.textContent = button.dataset.addingLabel;

          try {
            const response = await fetch(button.dataset.cartAddUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                items: [{ id: Number(button.dataset.variantId), quantity: 1 }]
              })
            });

            if (!response.ok) throw new Error('Unable to add item');
            window.location.assign(button.dataset.cartUrl);
          } catch (error) {
            button.disabled = false;
            button.textContent = button.dataset.errorLabel;
            window.setTimeout(() => {
              button.textContent = originalLabel;
            }, 2500);
          }
        }

        selectTab(selectedTab) {
          const updateCatalog = () => {
            this.tabs.forEach((tab) => {
              const isSelected = tab === selectedTab;
              tab.setAttribute('aria-selected', String(isSelected));
              tab.tabIndex = isSelected ? 0 : -1;
            });

            this.panels.forEach((panel) => {
              panel.hidden = panel.dataset.readyPanel !== selectedTab.dataset.readyTab;
            });
          };

          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          if (document.startViewTransition && !reduceMotion) {
            document.startViewTransition(updateCatalog);
          } else {
            updateCatalog();
          }
        }

        handleKeydown(event, currentTab) {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

          event.preventDefault();
          const currentIndex = this.tabs.indexOf(currentTab);
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const nextIndex = (currentIndex + direction + this.tabs.length) % this.tabs.length;
          const nextTab = this.tabs[nextIndex];

          this.selectTab(nextTab);
          nextTab.focus();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
